import { HERO } from '../../../core/constants/landing';
import { WHATSAPP_MESSAGES } from '../../../core/constants/site';
import { buildWhatsAppUrl } from '../../../core/utils/whatsapp';
import { IconArrowRight, IconWhatsApp } from '../../../common/icons';
import ViewfinderFrame from '../../../common/components/ViewfinderFrame/ViewfinderFrame';

import '../styles/hero.css';

export default function Hero() {
    return (
        <section className="hero" aria-labelledby="hero-title">
            <picture className="hero__media">
                <source
                    type="image/webp"
                    srcSet="/img/hero-lens-640.webp 640w, /img/hero-lens-960.webp 960w"
                    sizes="(max-width: 899px) 100vw, 62vw"
                />
                <img
                    className="hero__image"
                    src="/img/hero-lens-960.jpg"
                    width="960"
                    height="640"
                    alt=""
                    fetchPriority="high"
                    decoding="async"
                />
            </picture>
            <div className="hero__scrim" aria-hidden="true" />
            <ViewfinderFrame className="hero__frame" />

            <div className="hero__content container">
                <p className="eyebrow hero__eyebrow">{HERO.eyebrow}</p>
                <h1 id="hero-title" className="hero__title">
                    {HERO.titleStart}
                    <span className="hero__title-accent">{HERO.titleAccent}</span>
                    {HERO.titleEnd}
                </h1>
                <p className="hero__lead">{HERO.lead}</p>

                <div className="hero__actions">
                    <a
                        className="button button--whatsapp"
                        href={buildWhatsAppUrl(WHATSAPP_MESSAGES.quote)}
                        target="_blank"
                        rel="noopener"
                    >
                        <IconWhatsApp />
                        {HERO.primaryCta}
                    </a>
                    <a className="button button--ghost" href="#servicios">
                        {HERO.secondaryCta}
                        <IconArrowRight />
                    </a>
                </div>
            </div>
        </section>
    );
}
